import { theme } from '../constants/environment'

const cssVariables = {
	colors: {
		brand: {
			primary: '#566B76',
			secondary: theme==="pluxee"?'#342870':'#E95949',
		},
		semantic: {
			positive: '#88BC76',
			warning: '#FEB734',
			negative: '#EF7F43',
			information: '#62BDD0',
			disabled: '#DFDFDF',
		},
		grays: {
			lightGray: '#E6E6E6',
		},
		text: {
			primary: 'rgba(0, 0, 0, 0.78)',
			secondary: 'rgba(0, 0, 0, 0.6)',
			semantic: {
				positive: '#3F6732',
				warning: '#986301',
				negative: '#8D390C',
				information: '#236876',
			},
		},
		borders: {
			default: '#A3A3A3',
			divider: '#DFDFDF',
			ui: '#e4e4e4',
		},
		background: {
			primary: '#f8f8f8',
			secondary: '#FFFFFF',
			information: '#EBF7F9',
			warning: '#FFF4CC'
		},
	},
	fontSizes: {
		default: '14px',
		xs: '12px',
		sm: '13px',
		md: '14px',
		lg: '18px',
		xl: '20px',
		xxl: '24px',
	},
	spacings: {
		default: '12px',
		sm: '6px',
		md: '12px',
		lg: '18px',
		xl: '24px',
		xxl: '30px',
		xxxl: '48px',
		xxxxl: '60px',
	},
	borderRadiuses: {
		default: '3px',
		sm: '3px',
	},
}

export default cssVariables
